/* eslint-disable*/
import React, { lazy, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { themeChange } from "theme-change";
import checkAuth from "./app/auth";
import initializeApp from "./app/init";
import { checklogin } from "./utils/checklogin";
import { ToastProvider } from "./context/ToastContext";

// Importing pages
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Register = lazy(() => import("./pages/Register"));

// Initializing different libraries
initializeApp();

// Check for login and initialize axios
const token = checkAuth();

function App() {
  useEffect(() => {
    // 👆 daisy UI themes initialization
    themeChange(false);
  }, []);

  return (
    <>
      <ToastProvider>
        <Router>
          <Routes>
            <Route
              exact
              path="/login"
              name="Login Page"
              element={
                checklogin() ? (
                  <Navigate to={"/dashboard"} replace />
                ) : (
                  <Login />
                )
              }
            />

            <Route path="*" name="Home" element={<Layout />} />
          </Routes>
        </Router>
      </ToastProvider>
    </>
  );
}

export default App;
